import { Flex, Spinner } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import "./App.css";
import LoginPage from "./container/Auth/index";
import NotFound from "./container/NotFound/index";
import routes from "./routes/index";
import { Me } from "./store/actions/admin/admin.action";

function App() {
  const admin = useSelector((state) => state.admin.admin);
  const isAuthenticated = useSelector((state) => state.admin.isAuthenticated);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const isAdminEmpty = isEmpty(admin);

  useEffect(() => {
    if (location.pathname !== "/login") {
      async function fetchData() {
        if (isAdminEmpty) {
          setIsLoading(true);
          await dispatch(Me())
            .then(() => {
              setIsLoading(false);
              return;
            })
            .catch((_err) => {
              setIsLoading(false);
              history.push("/login");
            });
        }
      }
      fetchData();
    }
  }, [isAuthenticated, isAdminEmpty, dispatch, history, location.pathname]);

  if (isLoading)
    return (
      <Flex h="100vh" w="100vw" justify="center" align="center">
        <Spinner />
      </Flex>
    );
  return isAuthenticated ? (
    <Switch>
      {routes.map((data, index) => (
        <Route exact path={data.path} component={data.component} key={index} />
      ))}
      <Route component={NotFound} />
    </Switch>
  ) : (
    <Switch>
      <Route path="/login" component={LoginPage} />
    </Switch>
  );
}

export default App;

function isEmpty(obj) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return false;
    }
  }
  return JSON.stringify(obj) === JSON.stringify({});
}
